import { useMediaQuery } from "react-responsive";
import { appConfig } from "../../../config/app.config";
import { ICustomLabel } from "../../../interfaces/custom-label.interface";
import logoImg from '../../../assets/img/logo.png';
import { Animate } from "../../animation/animation";
import ReactMarkDown from 'react-markdown';
import { Visits } from "../visits/visits";
import Label from "../../common/label/label";
import styles from "./start-page-footer.module.scss";
import cn from 'classnames';
import { Fragment } from "react";

interface IStartPageFooterProps {
  label?: boolean;
  text?: string;
  disclamer?: string | boolean;
  domain?: string;
  customLabel?: ICustomLabel;
  whiteLabel?: boolean;
  visitsText?: string;
}

const disclamerText = "Имеются противопоказания, необходима консультация специалиста. Предложение не является публичной офертой";

export function StartPageFooter({ text, domain, customLabel, whiteLabel, visitsText, label, disclamer }: IStartPageFooterProps) {
  const logoUrl = customLabel?.image?.url ? appConfig().assets_url + customLabel?.image?.url : logoImg;
  const minWidth768 = useMediaQuery({ minWidth: 768 });

  return (<Animate when={true} delay={100} duration={500} animation={'fade'}>
    <footer className={styles.footer}>
      <div className={styles.visitsLabelBlock}>
        <Visits text={visitsText || "Сегодня тестов пройдено"} />
        {!minWidth768 && <Label
          place="start-page"
          logo={customLabel?.image?.url ? (appConfig().assets_url + customLabel?.image?.url) : logoImg}
          text={customLabel?.text}
          link={customLabel?.url}
        />}
      </div>
      <div className={cn(styles.flexBoxContainer)}>
        {((!whiteLabel || customLabel) && label && minWidth768) &&
          <Label place="start-page" domain={domain} logo={logoUrl} text={customLabel?.text} link={customLabel?.url} />
        }

        <div className={cn(styles.information, { [styles.whiteLabel]: whiteLabel })}>
          {disclamer !== false && <div className={styles.disclamer}>{disclamer || disclamerText}</div>}
          {text && <ReactMarkDown
            source={text}
            escapeHtml={false}
            renderers={{ paragraph: props => <Fragment children={props.children} /> }}
          />}
        </div>
      </div>
    </footer>
  </Animate>);
}